import client from '../../client'
import parseError from '../../lib/parseError'
import {
  REQUEST_ZIP_COUNTIES,
  RECEIVE_ZIP_COUNTIES,
  RECEIVE_ZIP_COUNTIES_ERROR
} from './consts'

function requestZipCounties() {
  return { type: REQUEST_ZIP_COUNTIES }
}

function receiveZipCounties(zipCounties) {
  return { type: RECEIVE_ZIP_COUNTIES, zipCounties }
}

// parseError reads `error.response.data`, so anything without that shape throws
// inside it rather than producing an error action -- a network failure carries no
// `response` at all, and the unwrapped message string this used to be handed has
// no `.response` either.
function axiosShaped(error) {
  if (error && error.response && error.response.data) return error

  return { response: { data: { error: (error && error.message) || 'An unknown error has occurred.' } } }
}

function receiveZipCountiesError(error) {
  const { generalError, resourceErrors } = parseError(axiosShaped(error))

  return { type: RECEIVE_ZIP_COUNTIES_ERROR, generalError, resourceErrors }
}

export default function getZipCounties(zipPrefix) {
  return (dispatch) => {
    dispatch(requestZipCounties())

    // Returned so onSearch can await the records, and rejects on failure --
    // resolving [] instead would render "No results found" for a failed request.
    return client.get(`/zip_counties?zip_prefix=${zipPrefix}`)
      .then((response) => response.data)
      .then((json) => {
        dispatch(receiveZipCounties(json))
        return json
      })
      .catch((error) => {
        dispatch(receiveZipCountiesError(error))
        throw error
      })
  }
}
